import { render, staticRenderFns } from "./2500_Custom_IR.vue?vue&type=template&id=5d94670e&scoped=true&lang=pug"
var script = {}
import style0 from "./2500_Custom_IR.vue?vue&type=style&index=0&id=5d94670e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d94670e",
  null
  
)

export default component.exports